import React from "react";

const Completed = props => (
  <svg viewBox="0 0 26 26" {...props}>
    <g
      transform="translate(1 1)"
      stroke="currentColor"
      fill="none"
      fillRule="evenodd"
    >
      <circle strokeWidth={1.455} cx={11.922} cy={11.935} r={11.879} />
      <path
        strokeWidth={1.212}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.104 11.142l3.954 4.426 7.903-7.27"
      />
    </g>
  </svg>
);

export default Completed;
